const tables = [
  { name: "Customer" },
  { name: "Total Receivable" },
  { name: "Outstanding" },
  { name: "0-30 Days" },
  { name: "31-60 Days" },
  { name: "61-90 Days" },
  { name: "90+ Days" },
  { name: "Invoice Count" },
  { name: "Action" },
];

export default tables;